import React from 'react';
import { FormProvider } from 'react-hook-form';
import { Box, Typography } from '@mui/material';
import { FieldV2 } from 'components/common/form-controls';

import styles from './partnershipDetails.style';

const PartnershipDetailsForm = ({ loading, canWrite, onSubmit, methods }) => {
  return (
    <FormProvider {...methods}>
      <form
        id="partnership-details-form"
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <Box sx={styles.sectionContainer}>
          <Box sx={styles.formGrid}>
            <FieldV2
              name="workHourCharge"
              label="Εργατοώρα €"
              type="number"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
            <FieldV2
              name="workDiscount"
              label="Έκπτωση Εργασίας (%)"
              type="number"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
            <FieldV2
              name="sparePartsDiscount"
              label="Έκπτωση Ανταλλακτικών (%)"
              type="number"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
            <FieldV2
              name="paymentTerms"
              label="Όροι πληρωμής (ημέρες)"
              type="number"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
            <FieldV2
              name="carsPerDay"
              label="Ροή Αυτοκινήτων / Ημέρα"
              type="number"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
            <FieldV2
              name="availableAppointments"
              label="Διαθέσιμα Ραντεβού / Ώρα Λειτουργίας"
              type="number"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
            <FieldV2
              name="technicalStaff"
              label="Τεχνικό Προσωπικό"
              type="checkbox"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.textFieldWrapper}
            />
          </Box>
        </Box>

        {/* Services Section */}
        <Box sx={styles.sectionContainer}>
          <Typography sx={styles.subsectionTitle}>Services</Typography>
          <Box sx={styles.checkboxGrid}>
            <FieldV2
              name="replacementVehicle"
              label="Οχήματα Εξυπηρέτησης"
              type="checkbox"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.checkboxFieldWrapper}
            />
            <FieldV2
              name="temporaryVehicleParking"
              label="Προσωρινή Στάθμευση Οχημάτων"
              type="checkbox"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.checkboxFieldWrapper}
            />
            <FieldV2
              name="isCertified"
              label="Certified"
              type="checkbox"
              control={methods.control}
              disabled={loading || !canWrite}
              wrapperStyle={styles.checkboxFieldWrapper}
            />
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default PartnershipDetailsForm;
